export enum IdTypeEnum {
  M_ID_CARD = 'M_ID_CARD',
  ID_CARD = 'ID_CARD'
}
